module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ill"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Papyrus from the Book of the Dead of Nakht, showing Spell 110. Thebes, late Eighteenth Dynasty, 1350–1300 "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BC")]), _vm._v(" ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Trustees of the British Museum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo2#photo2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back view of a crocodile-skin suit of armour from the third century "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AD")]), _vm._v(", discovered near Manfalut ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Trustees of the British Museum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo3#photo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map showing Egypt to Ethiopia from the Ptolemy manuscript, illustration from "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Memoires de la Societe Royale de Geographie d’Egypte,")]), _vm._v(" c.1470 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Private Collection/Bridgeman")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo4#photo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photograph of the Great Pyramid of Cheops reflected in the Nile overflow, c.1950 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("G. Eric and Edith Matson Photograph Collection/Library of Congress")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo5#photo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aerial photograph of the Aswan Dam, looking north, c.1936 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("G. Eric and Edith Matson Photograph Collection/Library of Congres")]), _vm._v("s)")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo6#photo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteenth-century illumination from "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Les Grandes Chroniques de France,")]), _vm._v(" showing Louis IX’s battle against the Saracens on the Nile ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("AKG/Erich Lessing")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo7#photo7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nilometer, Rhoda Island ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Radius Images/Corbis")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo8#photo8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Battle of the Nile, 1 August 1798 at 10 p.m.")]), _vm._v(" by Thomas Luny, 1834 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bonham’s, London/Bridgeman")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo9#photo9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Speke and Grant’s route from Zanzibar to the Nile, drawn and coloured by Grant with explanatory note by Speke dated 26 February 1863 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Royal Geographical Society")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo10#photo10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tissisat Falls ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Christophe Bolsvieux/Hemis/Corbis")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo11#photo11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albumen print of a house and garden in the French Quarter, Cairo, with Gustave Flaubert, 1850 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Private collection/Christie’s/Bridgeman")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo12#photo12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photograph of a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("dahabiya")]), _vm._v(" in Cairo, c.1860–90 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Library of Congress")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo13#photo13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographic print of boys shooting the rapids of the Nile on logs, c.1901 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("H.C. White Co./Library of Congress")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo14#photo14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stereograph showing palm trees partially submerged by water of the Nile, Cairo, c.1898 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("B.W. Kilburn/Library of Congress")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo15#photo15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("General Gordon’s Last Stand")]), _vm._v(" by George William Joy ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Leeds Art Gallery/Bridgeman")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo16#photo16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egyptian soldiers firing on President Anwar Al-Sadat while reviewing a military parade in honour of The October 1973 War, on 6 October, 1981 in Cairo ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Makaram Gad Alkareem/AFP/Getty Images")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo17#photo17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murchison Falls ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ric Ergenbright/Corbis")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ul-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo18#photo18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aerial photograph of Khartoum showing the confluence of the Blue and White Nile, taken from the Columbia space shuttle, 1990 ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Time and Life Pictures/Getty Images")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd0fd53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustration.vue
// module id = 66
// module chunks = 0